import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { parseTableParams } from '../../../utils/Utils';
import { buildReportLabels } from '../../../utils/reportLabels';
import DataTable from '../../../components/ui/DataTable';
import ReportExportButtons from '../../../components/ui/ReportExportButtons';

// Tek kaydırma: tablo kalan alanı alır (min-height: 0) — EmployeesPage aynası.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
`;

/**
 * AKM POC §7.2/§7.4 — yeni PDKS rapor listeleri için ortak sayfa: başlık yalnız DataTable'da, süzgeçler tablonun kendi
 * süzgeç sütunları, araç çubuğunda sunucu tarafı dışa aktarma (TAM veri, o anki süzgeçler); yerleşik CSV kapalı.
 * `report` = kancanın dönüşü ({ columns, data, fetching, pagination, queryParams, setQueryParams, filterList,
 * setFilterList, exportLabels? }).
 */
export default function TaListReportPage({
  title, report, exportUrl, formats, formatLabels,
}) {
  const { t } = useTranslation();
  const {
    columns, data, fetching, pagination, queryParams, setQueryParams, filterList, setFilterList, exportLabels,
  } = report;

  const handleDataStateChange = useCallback((action, tableState) => {
    setFilterList(tableState.filterList);
    setQueryParams(parseTableParams(tableState, columns));
  }, [columns, setFilterList, setQueryParams]);

  const handleFilterConfirm = useCallback((newFilterList) => setFilterList(newFilterList), [setFilterList]);

  const getLabels = useCallback(
    () => buildReportLabels(t, columns, title, exportLabels ? exportLabels() : {}),
    [t, columns, title, exportLabels],
  );

  const toolbarActions = useMemo(() => (
    <ReportExportButtons
      url={exportUrl}
      params={queryParams}
      getLabels={getLabels}
      formats={formats}
      formatLabels={formatLabels}
    />
  ), [exportUrl, queryParams, getLabels, formats, formatLabels]);

  return (
    <Container>
      {useMemo(() => (
        <DataTable
          title={title}
          fetching={fetching}
          columns={columns}
          data={data}
          totalRowCount={pagination.totalRowCount}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          filterList={filterList}
          onFilterConfirm={handleFilterConfirm}
          onTableChanged={handleDataStateChange}
          toolbarActions={toolbarActions}
          download={false}
        />
      ), [title, fetching, columns, data, pagination, filterList, handleFilterConfirm, handleDataStateChange, toolbarActions])}
    </Container>
  );
}
